const COLORS = {
    GRAY: '#131313',
    GRAY_LIGHT: '#eaeaea',
    GRAY_MEDIUM: '#bfbfbf',
    GRAY_DARK: '#817e7e',
    GRAY_DARKER: '#6f6f6f',
    YELLOW: '#ffae00ff',
    YELLOW_LIGHT: '#ffff1a',
    GREEN: '#348E38',
    GREEN_LIGHT: '#1aff1a',
    DARKRED: '#b90c09',
    DARKRED_LIGHT: '#ff1a1a',
    WHITE: '#ffffff',
    BLACK: '#000000',
    BLUE: '#0077c7ff',
    ORANGE: '#FF8C00',
    BROWN: '#7B5E57',
};

const SHADOWS = {
    DARK: `0.2rem 0.2rem 0.5rem 0 ${COLORS.GRAY}`,
    YELLOW: `0.2rem 0.2rem 0.5rem 0 ${COLORS.YELLOW}`,
    GREEN: `0.2rem 0.2rem 0.5rem 0 ${COLORS.GREEN}`,
    RED: `0.2rem 0.2rem 0.5rem 0 ${COLORS.DARKRED}`,
    LIGHT: `0.2rem 0.2rem 0.5rem 0 ${COLORS.GRAY_LIGHT}`,
};

export { COLORS, SHADOWS };
